import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import getThemeClasses from '@oxygen/theme';
import styles from './Rheostat.module.scss';
var propTypes = process.env.NODE_ENV !== "production" ? {
  /** If true it will show tooltip above handle */
  showTooltip: PropTypes.bool,

  /** Content for tooltip */
  children: PropTypes.node,

  /** Thumbs position on progress bar */
  thumbPosition: PropTypes.number,

  /** Max value for slider */
  maxValue: PropTypes.number,

  /** Min value for slider */
  minValue: PropTypes.number,

  /** Current value for slider */
  currentValue: PropTypes.number,

  /** If true handle will be disabled */
  disabled: PropTypes.bool,

  /** Callback fired on keyboard key press */
  onKeyDown: PropTypes.func,

  /** Callback fired on mouse button press */
  onMouseDown: PropTypes.func,

  /** Callback fired when touch starts on the handle */
  onTouchStart: PropTypes.func,

  /** Callback fired on click of the handle */
  onClick: PropTypes.func,

  /** If true handle will have active state */
  active: PropTypes.bool
} : {};
var defaultProps = {
  showTooltip: false,
  thumbPosition: 0,
  minValue: 0,
  currentValue: 0,
  disabled: false,
  active: false
};

var getThumbClasses = disabled => {
  var classes = "o-bXKmQE o-fuiuOo o-OisZk o-bJruGr o-foCBAZ o-cjsCNH o-cRSqer ".concat(styles.thumb, " ").concat(disabled ? "o-bLsNOY" : "o-frwuxB", "");
  return classes;
};

var getInnerBoxClasses = (disabled, active) => {
  var classes = "o-eVIFUq o-cUSgRL o-fuiuOo ".concat(disabled ? "o-cbkKHo" : "o-jeeUx", " ").concat(active ? styles.innerBox : '', "");
  return classes;
};

var centerArrowClasses = "o-dFbqSa ".concat(styles.tooltipArrowInCenter, "");

var getTooltipArrowClasses = (isTooltipInCenter, isTooltipLeftAligned, disabled) => "o-bXKmQE o-dJmcbh o-erPNDN o-eVvTDW ".concat(styles.tooltipArrow, " ").concat(disabled ? "o-cbkKHo" : "o-jeeUx", " ").concat(!isTooltipInCenter ? "o-iQjjl " : '', " ").concat(isTooltipInCenter ? centerArrowClasses : isTooltipLeftAligned ? "o-bewlMy" : styles.tooltipArrowInRight, "");

var getTooltipClasses = (isTooltipInCenter, disabled) => {
  var classes = "o-bXKmQE o-bVSleT o-fzoTov o-fzoTzh o-fzpimw o-fzpibK o-casNrQ o-dpkFbu o-eemiLE o-tvvmc ".concat(disabled ? "o-cbkKHo" : "o-jeeUx", " ").concat(styles.tooltip, " ").concat(isTooltipInCenter ? styles.tooltipInCenter : null, "");
  return classes;
};

var Handle = memo(function Handle(props) {
  var {
    showTooltip,
    isTooltipVisible,
    children,
    thumbPosition,
    maxValue,
    minValue,
    currentValue,
    disabled,
    onKeyDown,
    onMouseDown,
    onTouchStart,
    onClick,
    active,
    left
  } = props,
      other = _objectWithoutProperties(props, ["showTooltip", "isTooltipVisible", "children", "thumbPosition", "maxValue", "minValue", "currentValue", "disabled", "onKeyDown", "onMouseDown", "onTouchStart", "onClick", "active", "left"]);

  var isTooltipInCenter = thumbPosition > 15 && thumbPosition < 85;
  var isTooltipLeftAligned = thumbPosition < 16;
  var isTooltipRightAligned = thumbPosition > 84;
  var thumbClasses = getThumbClasses(disabled);
  var thumbStyles = {
    left: left
  };
  var innerBoxClasses = getInnerBoxClasses(disabled, active);
  var tooltipClasses = getTooltipClasses(isTooltipInCenter, disabled);
  var tooltipInlineStyles = {
    left: isTooltipInCenter ? '50%' : isTooltipLeftAligned ? 0 : null,
    right: isTooltipRightAligned ? 0 : null
  };
  var tooltipArrowClasses = getTooltipArrowClasses(isTooltipInCenter, isTooltipLeftAligned, disabled);
  return React.createElement("button", _extends({
    type: "button",
    className: thumbClasses,
    style: thumbStyles,
    role: "slider",
    "aria-valuemin": minValue,
    "aria-valuemax": maxValue,
    "aria-valuenow": currentValue,
    "aria-disabled": disabled,
    disabled: disabled,
    onClick: onClick,
    onKeyDown: !disabled ? onKeyDown : null,
    onMouseDown: !disabled ? onMouseDown : null,
    onTouchStart: !disabled ? onTouchStart : null,
    tabIndex: 0,
    "data-tooltip": showTooltip
  }, other), React.createElement("div", {
    className: innerBoxClasses
  }), showTooltip ? React.createElement("div", {
    role: "tooltip",
    style: tooltipInlineStyles,
    className: tooltipClasses
  }, children, React.createElement("span", {
    className: tooltipArrowClasses
  })) : '');
});
Handle.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
Handle.defaultProps = defaultProps;
export default Handle;